import { useTranslation } from 'react-i18next'

interface NewsItem {
  titleKey: string
  previewKey: string
  date?: string
}

const defaultNews: NewsItem[] = [
  {
    titleKey: 'landing.news.items.launch.title',
    previewKey: 'landing.news.items.launch.preview',
  },
  {
    titleKey: 'landing.news.items.tools.title',
    previewKey: 'landing.news.items.tools.preview',
  },
  {
    titleKey: 'landing.news.items.progress.title',
    previewKey: 'landing.news.items.progress.preview',
  },
]

export function News() {
  const { t } = useTranslation()
  // TODO: Загружать новости из API
  const news = defaultNews

  return (
    <section className="news" id="news">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('landing.news.title')}</h2>
          <p className="section-subtitle">{t('landing.news.subtitle')}</p>
        </div>
        <div className="news-grid">
          {news.map((item, index) => (
            <div key={index} className="news-card">
              <h3>{t(item.titleKey)}</h3>
              <p>{t(item.previewKey)}</p>
              {item.date && <div className="news-date">{item.date}</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
